

























import Vue from "vue";
import _ from "lodash";
import FilterSelect from "./FilterSelect.vue";
import { FilterTypes } from "@/scripts/enums";
import { createNamespacedHelpers } from "vuex";
import { reBuildColumns } from "@/utils/table";
import config from "@/config";

const { mapGetters, mapActions } = createNamespacedHelpers("base");

export default Vue.extend({
    name: "PlanFilter",
    components: { FilterSelect },
    props: {
        show: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        showSort: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        orgConfig: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isShow: this.show,
            occupationLevels: this.$constants.OCCUPATION_LEVELS,
            certificateTypes: this.$constants.CERTIFICATE_TYPES,
            registrationStatus: this.$constants.REGISTRATION_STATUS,
            pagination: {
                page: 0,
                size: this.$constants.QUERY_ALL_SIZE
            }
        };
    },
    methods: {
        confirm() {
            this.$emit("confirm");
        },
        open() {
            this.mapperOrgs();
            const classificationParams = _.merge({}, this.pagination, {
                orgId: this.$store.getters["home/searchForm"].orgId
            });
            this.mapperClassifications({ params: classificationParams });
            const occupationParams = _.merge({}, this.pagination, {
                orgId: this.$store.getters["home/searchForm"].orgId,
                classificationId: this.$store.getters["home/searchForm"].classificationId
            });
            this.mapperOccupations({ params: occupationParams });
        },
        closed() {
            this.$emit("closed");
        },
        resetFilter() {
            this.$store.dispatch("home/resetFilter");
            this.$store.dispatch("base/mapperOccupations", { params: this.pagination });
        },
        levels() {
            return _.map(this.occupationLevels, data => {
                return {
                    id: data,
                    name: this.$t("common.levelEnum." + data)
                };
            });
        },
        types() {
            return _.map(this.certificateTypes, data => {
                return {
                    id: data,
                    name: this.$t("common.certificateTypeEnum." + data)
                };
            });
        },
        status() {
            return _.map(this.registrationStatus, data => {
                return {
                    id: data,
                    name: this.$t("common.registrationStatusEnum." + data)
                };
            });
        },
        sortKey() {
            return [
                {
                    id: "new",
                    name: this.$t("common.sort.new")
                },
                {
                    id: "hot",
                    name: this.$t("common.sort.hot")
                }
            ];
        },
        ...mapActions(["mapperOrgs", "mapperClassifications", "mapperOccupations"])
    },
    computed: {
        trainingOccupationEnabled(): boolean {
            if (_.keys(this.orgConfig).length == 0) {
                return true;
            }
            return !!this.orgConfig["trainingOccupationEnabled"];
        },
        filterList(): any[] {
            return reBuildColumns(
                [
                    {
                        type: FilterTypes.ORG,
                        title: this.$t("common.base.org"),
                        content: this.orgs
                    },
                    {
                        type: FilterTypes.CLASSIFICATIONS,
                        title: this.$t("common.classification"),
                        content: this.classifications
                    },
                    {
                        type: FilterTypes.OCCUPATIONS,
                        title: this.$t("common.occupation"),
                        content: this.occupations
                    },
                    {
                        type: FilterTypes.LEVELS,
                        title: this.$t("common.level"),
                        content: this.levels()
                    },
                    {
                        type: FilterTypes.CERTIFICATE_TYPES,
                        title: this.$t("common.certificateType"),
                        content: this.types()
                    },
                    {
                        type: FilterTypes.REGISTRATION_STATUS,
                        title: this.$t("common.status"),
                        content: this.status()
                    },
                    {
                        type: FilterTypes.SORT_KEY,
                        title: this.$t("common.sort.label"),
                        content: this.sortKey()
                    }
                ],
                [
                    { name: FilterTypes.ORG, isShow: !this["AppConfigMixIn"].EXIST_SINGLE_ORG },
                    { name: FilterTypes.CLASSIFICATIONS, isShow: this.trainingOccupationEnabled },
                    { name: FilterTypes.OCCUPATIONS, isShow: this.trainingOccupationEnabled },
                    { name: FilterTypes.LEVELS, isShow: this.trainingOccupationEnabled },
                    { name: FilterTypes.SORT_KEY, isShow: this.showSort }
                ]
            );
        },
        ...mapGetters(["orgs", "classifications", "occupations"])
    },
    watch: {
        show(newVal) {
            this.isShow = newVal;
        }
    }
});
